import { SpreadsheetUtils } from 'basic-components';
import TimeService from 'dashboard-services/services/TimeService';

import dayjs from 'dayjs';

export const getNameWithoutType = name => 
  String(name)
    .replace("(D)", "")
    .replace("(DB)", "")
    .replace("(I)", "")
    .replace("(S)", "")
    .replace("(MD-S)", "")
    .replace("(MD-D)", "")
    .replace("(MD-DB)", "")
    .replace("(MD-I)", "")

export const getRowsChanges = ({ rows, colIndex, dateFormat, timezone, successRows, failCells, columnId, initDateArray }) => ([
  ...rows.filter(row => !String(row.rowId).startsWith("header")).map((row, index) => {
    const oldDate = initDateArray?.[index]
    let date;
    try {
      date = dayjs.tz(oldDate, dateFormat ? TimeService.translateFormat(dateFormat) : "YYYY-MM-DDTHH:mm:ss", timezone).utc().format("YYYY-MM-DDTHH:mm:ss")
      successRows.push(row.rowId)
    } catch(e) {
      console.error(e)
      date = oldDate;
      failCells.push({ columnNumber: colIndex, rowNumber: row.rowId, message: "There was a problem while formatting your date. Please change the date format." })
    }
    return SpreadsheetUtils.getRowChange({ row, colIndex, columnId, newValue: date })
  })
])

export const getHeaderChanges = ({ rows, colIndex, columnId, newValue }) => ([
  ...rows.filter(row => String(row.rowId).startsWith("header")).map(row => SpreadsheetUtils.getRowChange({ row, colIndex, columnId, newValue }))
])

export const onFail = ({ successRows, setIsSucess, setIsError, failCells, setSuccessMessage, setErrorMessage }) => {
  setSuccessMessage()
  setErrorMessage(`${successRows.length > 0 ? `${successRows.length} rows were formatted succesfully. ` : ``}${failCells?.length > 0 ? `Formatting ${failCells?.length} rows failed. Failed rows index: ${failCells.map(cell => cell?.rowNumber + 1)}` : "" }`)
  setIsSucess(false)
  setIsError(true)
}